import { useState } from "react";
import { fmtTime } from "@/lib/api";
import { usePoll, PageHeader, Pill, LEVEL_TONE } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const KINDS = ["all", "source_down", "switch", "failback", "off_air", "back_on_air", "limit_reached", "blocklist_refused", "access_denied", "repair", "retry", "silence", "push", "started", "stopped"];

export default function Incidents() {
  const [kind, setKind] = useState("all");
  const { data } = usePoll(`/admin/incidents?limit=300${kind !== "all" ? `&kind=${kind}` : ""}`, 4000);
  return (
    <div>
      <PageHeader title="Incidents" sub="Source down, switches with reason, off air / back on air, limits, blocklist, access denials and repairs."
        right={<Select value={kind} onValueChange={setKind}>
          <SelectTrigger data-testid="incident-kind-filter" className="w-52 bg-[#0F1722] border-slate-700 font-mono text-xs"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-[#16202E] border-slate-700">{KINDS.map((k) => <SelectItem key={k} value={k} className="font-mono text-xs">{k}</SelectItem>)}</SelectContent>
        </Select>} />
      <div className="bg-[#0F1722] border border-slate-800 rounded-md" data-testid="incident-feed">
        {(data || []).map((e) => (
          <div key={e.id} className={`flex items-center gap-3 px-4 py-2 border-b border-slate-800/60 text-xs border-l-2 ${e.level === "crit" ? "border-l-red-500" : e.level === "warn" ? "border-l-amber-500" : e.level === "ok" ? "border-l-emerald-500" : "border-l-transparent"}`}>
            <span className="font-mono text-slate-500 w-32 shrink-0">{fmtTime(e.ts, true)}</span>
            <span className="w-36 shrink-0"><Pill tone={LEVEL_TONE[e.level]}>{e.kind}</Pill></span>
            <span className="font-mono text-cyan-300 w-28 shrink-0 truncate">{e.channel_slug || "—"}</span>
            <span className="text-slate-300">{e.message}</span>
          </div>
        ))}
        {data && data.length === 0 && <p className="text-sm text-slate-500 p-4">No incidents.</p>}
      </div>
    </div>
  );
}
